import styled from 'styled-components';

import colors from 'styles/colors';

import sizes from 'styles/sizes';

export const Container = styled.div`
  @media (min-width: ${sizes.media.smallMaxWidth + 0.5}px) {
    padding: 0 ${sizes.gutter.small}px;
  }
  @media (min-width: ${sizes.media.mediumMaxWidth + 0.5}px) {
    padding: 0 ${sizes.gutter.large}px;
  }
`;
export const Wrapper = styled.div`
  align-items: center;
  background: ${props => props.$background};
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  margin-block: 15px;
  max-width: ${sizes.constrains.desktop}px;
  @media (min-width: ${sizes.media.smallMaxWidth + 0.5}px) {
    box-shadow: 0px 2px 4px ${colors.secondary.deepCove}15;
    border-radius: 5px;
    flex-direction: row;
    margin: 30px auto;
  }
  @media (min-width: ${sizes.media.mediumMaxWidth + 0.5}px) {
    box-shadow: 0px 2px 4px ${colors.secondary.deepCove}15;
    border-radius: 5px;
    flex-direction: row;
    margin: 30px auto;
  }
`;
export const Icon = styled.div`
  align-items: center;
  display: flex;
  min-height: 40px;
  min-width: 60px;
  justify-content: center;
  padding: 10px 15px;
  width: 100%;
  position: relative;
  font-size: 14px;
  display: flex;
  line-height: 21px;
  p {
    padding: 0 25px 0 5px;
  }
  @media (min-width: ${sizes.media.smallMaxWidth + 0.5}px) {
    padding: 10px 20px;
    min-height: 85px;
    width: 60px;
    min-width: 60px;
    font-size: 18px;
    padding: 8px 16px;
  }
  @media (min-width: ${sizes.media.mediumMinWidth + 0.5}px) {
    min-height: 99px;
  }
`;
export const ContentPromo = styled.div`
  align-items: center;
  background: ${colors.primary.ice};
  flex-grow: 1;
  font-size: 16px;
  min-height: 85px;
  justify-content: center;
  color: ${props => props.$color};
  padding: 20px 15px;
  display: inline-flex;
  gap: 10px;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${sizes.media.smallMaxWidth + 0.5}px) {
	border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 20px;
    flex-direction: row;
    width: auto;
    justify-content: flex-start;
  }
  @media (min-width: ${sizes.media.mediumMinWidth + 0.5}px) {
    min-height: 99px;
  }
}
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  margin-top: -10px;
  position: absolute;
  right: 15px;
  width: 15px;

  path {
    transition: stroke 0.1s cubic-bezier(0, 0, 0, 0);
  }

  svg {
    padding-bottom: 0px;
    width: 15px;
    height: 15px;
  }

  &:hover {
    path {
      stroke: ${colors.primary.ocean};
    }
  }

  @media (min-width: ${sizes.media.smallMaxWidth + 0.5}px) {
    top: 10px;
    right: 10px;
    width: 15px;
    margin-top: 0px;
  }
`;

export const ContentText = styled.div`
  width: 100%;
  font-size: 16px;
  span,
  a {
    line-height: 150%;
  }
  @media (min-width: ${sizes.media.smallMaxWidth + 0.5}px) {
    width: ${props => (props.action == 1 ? 'calc(100% - 225px);' : '100%')} 
    margin-bottom: 0px;
    p:first-child {
      line-height: 21px;
      margin-bottom: 5px;
      font-size: 14px;
    }
    span,
    a {
      font-size: 12px;
      line-height: 18px;
    }
  }
  @media (min-width: ${sizes.media.mediumMinWidth + 0.5}px) {
    p:first-child {
      font-size: 16px;
      line-height: 27px;
    }
    span,
    a {
      font-size: 14px;
      line-height: 24px;
    }
  }
  @media (min-width: ${sizes.media.tabletLandscape + 0.5}px) {
    p:first-child {
      font-size: 18px;
      line-height: 27px;
    }
    span,
    a {
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const ContentAction = styled.div`
  width: 100%;
  @media (min-width: ${sizes.media.smallMaxWidth + 0.5}px) {
    width: auto;
    margin-left: 40px;
    margin-right: 20px;
  }
`;
